export default "__VITE_ASSET__NQPA7Dap__"